import scrollIntoView from 'scroll-into-view-if-needed';
import { ItemClass, ItemUtils, selectors, ShapeType, TextUtils, } from '@marvelapp/design-creator';
export function isSymbolLayer(layer) {
    var _a, _b;
    var itemData = ItemUtils.getData(layer);
    var symbolName = (_b = (_a = itemData === null || itemData === void 0 ? void 0 : itemData['MARVEL_SKETCH_PLUGIN']) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.symbolName;
    return !!symbolName;
}
export function getDefaultLayerLabel(layer) {
    var className = ItemUtils.getClassName(layer);
    switch (className) {
        case ItemClass.Group: {
            if (isSymbolLayer(layer)) {
                return 'Symbol';
            }
            return 'Group';
        }
        case ItemClass.Raster:
            return 'Image';
        case ItemClass.Shape: {
            var type = ItemUtils.getShapeType(layer);
            if (type === ShapeType.Ellipse) {
                return 'Ellipse';
            }
            if (type === ShapeType.Rectangle) {
                return 'Rectangle';
            }
            return 'Shape';
        }
        case ItemClass.CompoundPath:
        case ItemClass.Path:
            return 'Path';
        case ItemClass.Text: {
            return TextUtils.getBlock(layer, 0);
        }
        default:
            return '';
    }
}
// Given a design and layerIds array, the function returns a map
// of id->true, containing ids of the ancestors of each layer
export function getExpandedAncestors(design, layerIds) {
    var expandedAncestors = layerIds.reduce(function (res, layerId) {
        var layerIdAncestors = selectors.getAncestorIds(design, layerId);
        layerIdAncestors.forEach(function (id) {
            res[id] = true;
        });
        return res;
    }, {});
    return expandedAncestors;
}
export function scrollToLayer(elem) {
    if (elem) {
        scrollIntoView(elem, {
            scrollMode: 'if-needed',
        });
    }
}
